// src/stage2/sceneExterior/TablesField.jsx
import React from 'react';
import { useGLTF } from '@react-three/drei';

const TABLE_URL = '/stageAssets/stage2/scene/Stage2Exterior-OldTable.glb';

export function TablesField() {
  // Load the *one* table model
  const { scene } = useGLTF(TABLE_URL);

  // All the places you want tables to appear (R3F coords)
  const tables = [
    { id: 't1', pos: [36.5, 1.8, 19.5], ros: [0, Math.PI * -0.25, 0] },
    { id: 't2', pos: [34.25, 1.85, 15.1], ros: [0, Math.PI * 0.25, 0] },
    { id: 't3', pos: [29, 1.85, 11], ros: [0, Math.PI , 0] },
    { id: 't4', pos: [28.5, 1.85, 15.8], ros: [0, Math.PI * 2, 0] },
    { id: 't5', pos: [34.5, 1.8, 9], ros: [-0.09, Math.PI * 0.1, 0] },

  ];

  if (!scene) return null;

  return (
    <>
      {tables.map((t) => (
        <primitive
          key={t.id}
          object={scene.clone(true)}   // cheap clone per instance
          position={t.pos}
          rotation={t.ros}
          // You can also tweak rotation/scale per table if needed:
          // rotation={[0, Math.PI * 0.25, 0]}
          scale={1.5}
        />
      ))}
    </>
  );
}

useGLTF.preload(TABLE_URL);
